import { render, staticRenderFns } from "./EventCategoryPage.vue?vue&type=template&id=163efea3"
import script from "./EventCategoryPage.vue?vue&type=script&lang=js"
export * from "./EventCategoryPage.vue?vue&type=script&lang=js"
import style0 from "./EventCategoryPage.vue?vue&type=style&index=0&id=163efea3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports